
import { defineComponent } from '@vue/composition-api';

const listContent = {
  included: [
    'Boxing Bag + Bag Ring',
    'Boxing Gloves',
    'Console + 4 Trackers',
    'Quick Wraps',
    'Ankle Wraps',
    'Heart Rate Monitor',
  ],
  whyFC: [
    'Improved focus',
    'Stress relief',
    'Increased metabolism',
    'Improve balance and posture',
    'Promote longevity',
  ],
};

export default defineComponent({
  name: 'PDP10Bullets',
  setup() {
    return {
      listContent,
    };
  },
});
